 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_HALTITLE from '@/components/xhtml/01_Haltitle'
 import XHTML02_FM01 from '@/components/xhtml/02_Fm01'
 import XHTML03_TITLE from '@/components/xhtml/03_Title'
 import XHTML04_COPYRIGHT from '@/components/xhtml/04_Copyright'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML05_PREFACE from '@/components/xhtml/05_Preface'
 import XHTML06_ACKNOWLEDGMENTS from '@/components/xhtml/06_Acknowledgments'
 import XHTML07_STRUCTURE from '@/components/xhtml/07_Structure'
 import XHTML08_SOME from '@/components/xhtml/08_Some'
 import XHTML09_CHRONOLOGY from '@/components/xhtml/09_Chronology'
 import XHTML10_CHRONOLOGY1 from '@/components/xhtml/10_Chronology1'
 import XHTML11_HISTORICAL from '@/components/xhtml/11_Historical'
 import XHTML12_CIVILIAN from '@/components/xhtml/12_Civilian'
 import XHTML13_SUCCESSORS from '@/components/xhtml/13_Successors'
 import XHTML14_SUBSIDIARY from '@/components/xhtml/14_Subsidiary'
 import XHTML15_TRANS from '@/components/xhtml/15_Trans'
 import XHTML16_FLEET from '@/components/xhtml/16_Fleet'
 import XHTML17_NAVAL from '@/components/xhtml/17_Naval'
 import XHTML18_DEPARTMENTAL from '@/components/xhtml/18_Departmental'
 import XHTML19_SPANISH from '@/components/xhtml/19_Spanish'
 import XHTML20_ARCHITECTURE from '@/components/xhtml/20_Architecture'
 import XHTML21_COPPER from '@/components/xhtml/21_Copper'
 import XHTML22_MATERIAL from '@/components/xhtml/22_Material'
 import XHTML23_PERSONNEL from '@/components/xhtml/23_Personnel'
 import XHTML24_SOURCES from '@/components/xhtml/24_Sources'
 import XHTML25_BIBLIOGRAPHY from '@/components/xhtml/25_Bibliography'
 import XHTML26_GLOSSARY from '@/components/xhtml/26_Glossary'
 import XHTML27_CHAPTER_01 from '@/components/xhtml/27_Chapter_01'
 import XHTML28_CHAPTER_02 from '@/components/xhtml/28_Chapter_02'
 import XHTML29_CHAPTER_03 from '@/components/xhtml/29_Chapter_03'
 import XHTML30_CHAPTER_04 from '@/components/xhtml/30_Chapter_04'
 import XHTML31_CHAPTER_05 from '@/components/xhtml/31_Chapter_05'
 import XHTML32_CHAPTER_06 from '@/components/xhtml/32_Chapter_06'
 import XHTML33_CHAPTER_07 from '@/components/xhtml/33_Chapter_07'
 import XHTML34_CHAPTER_08 from '@/components/xhtml/34_Chapter_08'
 import XHTML35_CHAPTER_09 from '@/components/xhtml/35_Chapter_09'
 import XHTML36_CHAPTER_10 from '@/components/xhtml/36_Chapter_10'
 import XHTML37_CHAPTER_11 from '@/components/xhtml/37_Chapter_11'
 import XHTML38_CHAPTER_12 from '@/components/xhtml/38_Chapter_12'
 import XHTML39_CHAPTER_13 from '@/components/xhtml/39_Chapter_13'
 import XHTML40_CHAPTER_14 from '@/components/xhtml/40_Chapter_14'
 import XHTML41_CHAPTER_15 from '@/components/xhtml/41_Chapter_15'
 import XHTML42_CHAPTER_16 from '@/components/xhtml/42_Chapter_16'
 import XHTML43_CHAPTER_17 from '@/components/xhtml/43_Chapter_17'
 import XHTML44_CHAPTER_18 from '@/components/xhtml/44_Chapter_18'
 import XHTML45_CHAPTER_19 from '@/components/xhtml/45_Chapter_19'
 import XHTML46_CHAPTER_20 from '@/components/xhtml/46_Chapter_20'
 import XHTML47_CHAPTER_21 from '@/components/xhtml/47_Chapter_21'
 import XHTML48_CHAPTER_22 from '@/components/xhtml/48_Chapter_22'
 import XHTML49_CHAPTER_23 from '@/components/xhtml/49_Chapter_23'
 import XHTML50_CHAPTER_24 from '@/components/xhtml/50_Chapter_24'
 import XHTML51_ADDENDUM from '@/components/xhtml/51_Addendum'
 import XHTML52_APPENDIX_A from '@/components/xhtml/52_Appendix_A'
 import XHTML53_APPENDIX_B from '@/components/xhtml/53_Appendix_B'
 import XHTML54_APPENDIX_C from '@/components/xhtml/54_Appendix_C'
 import XHTML55_APPENDIX_D from '@/components/xhtml/55_Appendix_D'
 import XHTML56_APPENDIX_E from '@/components/xhtml/56_Appendix_E'
 import XHTML57_APPENDIX_F from '@/components/xhtml/57_Appendix_F'
 import XHTML58_APPENDIX_G from '@/components/xhtml/58_Appendix_G'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/01_Haltitle",
 			"name" : "xhtml/01_Haltitle",
 			"component" : XHTML01_HALTITLE
 		},
 		{
 			"path" : "/xhtml/02_Fm01",
 			"name" : "xhtml/02_Fm01",
 			"component" : XHTML02_FM01
 		},
 		{
 			"path" : "/xhtml/03_Title",
 			"name" : "xhtml/03_Title",
 			"component" : XHTML03_TITLE
 		},
 		{
 			"path" : "/xhtml/04_Copyright",
 			"name" : "xhtml/04_Copyright",
 			"component" : XHTML04_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/05_Preface",
 			"name" : "xhtml/05_Preface",
 			"component" : XHTML05_PREFACE
 		},
 		{
 			"path" : "/xhtml/06_Acknowledgments",
 			"name" : "xhtml/06_Acknowledgments",
 			"component" : XHTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/07_Structure",
 			"name" : "xhtml/07_Structure",
 			"component" : XHTML07_STRUCTURE
 		},
 		{
 			"path" : "/xhtml/08_Some",
 			"name" : "xhtml/08_Some",
 			"component" : XHTML08_SOME
 		},
 		{
 			"path" : "/xhtml/09_Chronology",
 			"name" : "xhtml/09_Chronology",
 			"component" : XHTML09_CHRONOLOGY
 		},
 		{
 			"path" : "/xhtml/10_Chronology1",
 			"name" : "xhtml/10_Chronology1",
 			"component" : XHTML10_CHRONOLOGY1
 		},
 		{
 			"path" : "/xhtml/11_Historical",
 			"name" : "xhtml/11_Historical",
 			"component" : XHTML11_HISTORICAL
 		},
 		{
 			"path" : "/xhtml/12_Civilian",
 			"name" : "xhtml/12_Civilian",
 			"component" : XHTML12_CIVILIAN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js